import DOMPurify from 'dompurify';

const markedLib = require('marked');

const markedParser =
  (typeof markedLib?.parse === 'function' && markedLib.parse) ||
  (typeof markedLib?.marked === 'function' && markedLib.marked) ||
  (typeof markedLib?.default?.parse === 'function' && markedLib.default.parse) ||
  (typeof markedLib?.default?.marked === 'function' && markedLib.default.marked) ||
  (typeof markedLib?.default === 'function' && markedLib.default) ||
  (typeof markedLib === 'function' && markedLib) ||
  ((text) => text);

if (typeof markedLib?.setOptions === 'function') {
  markedLib.setOptions({ breaks: true, gfm: true });
} else if (typeof markedLib?.marked?.setOptions === 'function') {
  markedLib.marked.setOptions({ breaks: true, gfm: true });
} else if (typeof markedLib?.default?.setOptions === 'function') {
  markedLib.default.setOptions({ breaks: true, gfm: true });
}

const communicationMarkdownLinkHook = (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
};

let communicationPurifyHookRegistered = false;
if (typeof DOMPurify?.addHook === 'function' && !communicationPurifyHookRegistered) {
  DOMPurify.addHook('afterSanitizeAttributes', communicationMarkdownLinkHook);
  communicationPurifyHookRegistered = true;
}

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li', 'code', 'pre', 'blockquote',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
];
const ALLOWED_ATTR = ['href', 'title', 'rel', 'target'];

/**
 * Render note markdown to sanitized HTML for v-html.
 * @param {string} text
 * @returns {string}
 */
export function renderCommunicationMarkdown(text) {
  if (!text) return '';
  try {
    const rawHtml = markedParser(String(text));
    return DOMPurify.sanitize(rawHtml, {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
    });
  } catch {
    return DOMPurify.sanitize(String(text).replace(/\n/g, '<br>'));
  }
}
